export const RoleDetailsTabsEnum = {
  OVERVIEW: 0,
  PERMISSIONS: 1,
  USERS: 2,
};

export default RoleDetailsTabsEnum;

